import { Navigator } from '@/mixins/Navigator'

const mixin = new Navigator()

export function date(value: string, options?: Intl.DateTimeFormatOptions, placeholder = '-', offset = false) {
  if (!value) return placeholder
  value = value.toString()
  const date = new Date(value)

  if (offset && !mixin.navigator.isSafari) date.setHours(date.getHours() - date.getTimezoneOffset() / 60)
  return date.toLocaleDateString('Ru-ru', options)
}
